<button
    (click)="closeAuthModal()"
    *ngIf="activeModal"
    aria-label="Close"
    class="close"
    type="button"
>
    <i class="pbslm-close-thin-cross close-img"></i>
</button>
<div id="auth-modal">
    <div class="modal-header">
        <h2 class="title modal-title-text">{{ title }}</h2>
    </div>
    <div class="modal-body">
        <div class="tabs-wrapper">
            <a (click)="activateTeacherTab()" [ngClass]="{ active: !isStudentTab }"> Teacher </a>
            <a
                (click)="activateStudentTab()"
                *ngIf="activeModal"
                [ngClass]="{ active: isStudentTab }"
                class="selenium-modal-student-link"
            >
                Student
            </a>
            <a
                (click)="openStudentSignUp()"
                *ngIf="!activeModal"
                class="selenium-modal-student-link"
            >
                Student
            </a>
        </div>
        <div class="description-wrapper modal-body-text">
            <p>
                {{ description }}
            </p>
        </div>
        <!-- Region: Teacher Auth Buttons -->
        <div *ngIf="!isStudentTab" class="auth-links-wrapper">
            <a [href]="googleAuthUrl" class="auth google">
                <img [src]="googleImage" alt="Google Auth" class="auth-icon" />
                Sign in with Google
            </a>
            <a [href]="facebookAuthUrl" class="auth facebook">
                <img [src]="facebookImage" alt="Facebook Auth" class="auth-icon" />
                Sign in with Facebook
            </a>
            <a [href]="pbsAuthUrl" class="auth pbs">
                <em class="auth-icon fas fa-envelope"></em>
                Sign in with Email
            </a>
        </div>
        <!-- /Region: Teacher Auth Buttons -->
        <div *ngIf="activeModal && isStudentTab" class="student-auth-wrapper">
            <!-- Region: Student Auth Step One -->
            <div
                *ngIf="studentLogin.shouldDisplayUsernameInput()"
                class="student-auth-step-one-wrapper"
            >
                <div class="student-sign-in-text modal-body-text">
                    Sign in using your PBS LearningMedia username:
                </div>
                <div class="username-input position-relative">
                    <app-input-box
                        (click)="
                            studentLogin.isLoginInitiated = false;
                            studentLogin.restoreInitialSecretQuestionValue()
                        "
                        (keydown.enter)="studentLogin.initiateLogin(studentUsername)"
                        [(inputModel)]="studentUsername"
                        label="Username"
                    >
                    </app-input-box>
                    <app-button (click)="studentLogin.initiateLogin(studentUsername)">
                        Next
                    </app-button>
                </div>
                <app-error-message
                    *ngIf="
                        studentLogin.getSecretQuestion() === null && studentLogin.isLoginInitiated
                    "
                    errorMessage="This username does not exist."
                >
                </app-error-message>
            </div>
            <!-- /Region: Student Auth Step One -->
            <!-- Region: Student Auth Step Two -->
            <div
                *ngIf="studentLogin.shouldDisplayQuestionInput()"
                class="student-auth-step-two-wrapper"
            >
                <div class="student-sign-in-text modal-body-text">
                    Answer your secret question to finish signing in. <br />
                    {{ studentLogin.getSecretQuestion() }}
                </div>
                <div class="secret-answer-input">
                    <app-input-box
                        (click)="
                            studentLogin.isLoginValidationInitiated = false;
                            studentLogin.restoreInitialLoginEvaluationValue()
                        "
                        (keydown.enter)="studentLogin.validateLogin(secretAnswer)"
                        [(inputModel)]="secretAnswer"
                        label="{{ studentLogin.generateLabelFromSecretQuestion() }}"
                    >
                    </app-input-box>
                    <app-button (click)="studentLogin.validateLogin(secretAnswer)"> Go</app-button>
                </div>
                <app-error-message
                    *ngIf="
                        studentLogin.getLoginValidity() === 'False' &&
                        studentLogin.isLoginValidationInitiated
                    "
                    errorMessage="This answer does not match your original one. Please try again."
                >
                </app-error-message>
            </div>
            <!-- /Region: Student Auth Step Two -->
            <hr />
            <div class="google-auth-wrapper">
                <a [href]="googleAuthUrl" class="auth google selenium-continue-google">
                    <img [src]="googleImage" alt="Google Auth" class="auth-icon" />
                    Sign in with Google
                </a>
            </div>
        </div>
        <div *ngIf="activeModal" class="register-caption-wrapper">
            <span>{{ registerDescription }}</span>
            <span *ngIf="!isStudentTab">
                <a
                    (click)="closeAuthModal()"
                    class="selenium-modal-signup-link"
                    href="/signup/"
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    {{ registerLinkText }}
                    <em class="fas fa-external-link-alt"></em>
                </a>
            </span>
            <span *ngIf="isStudentTab">
                <a
                    (click)="openStudentSignUp()"
                    class="selenium-modal-signup-link"
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    {{ registerLinkText }}
                    <em class="fas fa-external-link-alt"></em>
                </a>
            </span>
        </div>
        <div *ngIf="!activeModal" class="register-caption-wrapper modal-body-text">
            <span class="modal-body-text">{{ registerDescription }}</span>
            <span>
                <a (click)="isStudent ? openStudentAuthModal() : openAuthModal()">{{
                    registerLinkText
                }}</a>
            </span>
        </div>
    </div>
</div>
